/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLayoutAlignTop = createReactComponent("layout-align-top", "IconLayoutAlignTop", [
  ["path", { d: "M4 4l16 0", key: "svg-0" }],
  [
    "path",
    {
      d: "M9 8m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z",
      key: "svg-1"
    }
  ]
]);

export { IconLayoutAlignTop as default };
//# sourceMappingURL=IconLayoutAlignTop.js.map
